import { render, staticRenderFns } from "./verify-code.vue?vue&type=template&id=3013d63e&scoped=true"
import script from "./verify-code.vue?vue&type=script&lang=ts"
export * from "./verify-code.vue?vue&type=script&lang=ts"
import style0 from "./verify-code.vue?vue&type=style&index=0&id=3013d63e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3013d63e",
  null
  
)

export default component.exports